import {
  PageContainer,
  PageContentContainer,
} from "../../components/PageContainer";
import { InfoText } from "../../components/texts/InfoText";

export const UserAppRatingCompleted = () => {
  return (
    <PageContainer>
      <PageContentContainer>
        <InfoText
          headline="Danke für dein Feedback!"
          text={[
            "Deine Meinung ist uns wichtig und hilft uns, die Physiofit-App stetig zu verbessern.",
          ]}
        />
      </PageContentContainer>
    </PageContainer>
  );
};
